import clsx from 'clsx'
import {
  isEqual,
  isFirstDayOfMonth,
  isLastDayOfMonth,
  isMonday,
  isSunday,
  isWeekend,
  startOfDay
} from 'date-fns'
import React from 'react'
import DatePicker from 'react-datepicker'

import Text from '@/components-latest/primitives/Text'

import Styles from './DateRangeCalendar.module.scss'

type Props = {
  startDate: Date | null
  endDate: Date | null
  onChange: (dates: [Date, Date]) => void
}

const DateRangeCalendar = ({ onChange, endDate, startDate }: Props) => {
  return (
    // @ts-ignore
    <DatePicker
      calendarClassName={Styles.calendar}
      startDate={startDate}
      selected={startDate}
      selectsRange
      endDate={endDate}
      onChange={onChange}
      calendarStartDay={1}
      useWeekdaysShort={true}
      showPreviousMonths={false}
      weekDayClassName={date =>
        clsx(Styles.weekDay, {
          [Styles.weekEnd]: isWeekend(date)
        })
      }
      monthsShown={2}
      renderDayContents={(dayNumber, date: Date) => {
        const _isFirstDayOfMonth = isFirstDayOfMonth(date)
        const _isLastDayOfMonth = isLastDayOfMonth(date)

        const isStartDate = startDate
          ? isEqual(startOfDay(startDate), date)
          : false

        const isEndDate = endDate ? isEqual(startOfDay(endDate), date) : false

        const _isMonday = isMonday(date)
        const _isSunday = isSunday(date)

        return (
          <Text
            asChild
            className={clsx(Styles.date, {
              [Styles.shapeFirst]:
                isStartDate || _isMonday || _isFirstDayOfMonth,
              [Styles.shapeLast]: isEndDate || _isSunday || _isLastDayOfMonth,
              [Styles.backgroundNone]:
                ((_isLastDayOfMonth || _isSunday) && isStartDate) ||
                ((_isFirstDayOfMonth || _isMonday) && isEndDate),
              [Styles.startDate]: isStartDate
            })}>
            <p>{dayNumber}</p>
          </Text>
        )
      }}
      inline
    />
  )
}

export default DateRangeCalendar
